<ng-template #rt let-r="result" let-t="term">
  {{ r.destination }} ({{ r.gateway.toUpperCase() }})
</ng-template>
@if (
  {
    terminals: searchParameters?.terminals | async,
    isArrivalLoading: isArrivalLoading | async
  };
  as data
) {
  <div class="parking-search-container">
    @if (searchParameters?.clonedBasketItemDetails?.name) {
      <div>
        <app-cloned-details
          [name]="searchParameters?.clonedBasketItemDetails?.name"
        ></app-cloned-details>
      </div>
    }
    <div class="half-container">
      <div class="half-block">
        <label class="header-label" id="airportlabel" for="airport" i18n="@@mbiLoungeAirport"
          >Airport</label
        >
        <i class="ico-flight combo-box-icon" aria-hidden="true"></i>
        <div class="flex-row-container">
          <input
            #inputAirport="ngbTypeahead"
            autocomplete="off"
            type="text"
            id="airport"
            i18n-placeholder
            placeholder="Enter an airport"
            (click)="$event.target.select()"
            name="travellingFrom"
            [inputFormatter]="formatAirports"
            [ngbTypeahead]="getAirports"
            [(ngModel)]="searchParameters.locationCode"
            [resultTemplate]="rt"
            (focus)="airportsFocus$.next($event.target.value)"
            (click)="airportsClick$.next($event.target.value)"
            appInput
            aria-labelledby="airportlabel"
            (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
            (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            [ngClass]="{
              'error-box': searchParameters.validationMessages?.includes(
                'You must select airport first.'
              )
            }"
          />
          @if (loadingAirports) {
            <i class="button_spinner input-loading-spinner-left"></i>
          }
        </div>
      </div>
      <div class="half-block">
        <div class="half-container">
          <div class="half-block">
            <label
              class="header-label"
              id="terminallabel"
              i18n="@@ParkingSearchTerminal"
              for="parking_terminal"
              >Terminal</label
            >
            @if (data.terminals.length === 0) {
              <p i18n="@@ParkingSearchSelectAirportFirst">Select airport first</p>
            }
            <select
              appSelect
              [(ngModel)]="searchParameters.terminal"
              class="terminals"
              id="parking-select-terminal"
            >
              @for (terminal of data.terminals; track terminal) {
                <option [ngValue]="terminal.value">
                  {{ terminal.key | translate }}
                </option>
              }
            </select>
          </div>
          <div class="half-block">
            <label class="header-label" for="Flightnumberlabel" i18n="@@ParkingSearchFlightNumber"
              >Flight number</label
            >
            <input
              appInput
              [noIcon]="true"
              i18n-placeholder
              placeholder="Enter flight number"
              [(ngModel)]="searchParameters.outFlightNumber"
              id="Flightnumberlabel"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="journey-panel">
      <div class="half-container">
        <div class="half-block left-block">
          <div
            class="flex-row-container"
            [ngClass]="{
              'error-box': searchParameters.validationMessages?.includes(
                'Outward journey cannot be in the past.'
              )
            }"
          >
            <ngbd-datepicker-i18n>
              <div class="flex-column-container combo-box-left">
                <i
                  class="ico-calendar combo-box-icon"
                  aria-hidden="true"
                  style="cursor: pointer"
                ></i>
                <label
                  class="header-label date-label"
                  i18n="@@apartmentSearchOutboundDateAndTime"
                  for="parking-search-outward-date"
                  >Check-in date (DD/MM/YYYY)</label
                >
                <app-datepicker
                  [minDate]="min_date"
                  [startDate]="searchParameters.outdate"
                  [model]="searchParameters.outdate"
                  [from]="searchParameters.outdate"
                  [to]="searchParameters.indate"
                  (newFrom)="searchParameters.outdate = $event"
                  (newTo)="searchParameters.indate = $event"
                  [class]="'combo-box'"
                  [componentId]="'parking-search-outward-date'"
                  (newDate)="searchParameters.outdate = $event"
                >
                </app-datepicker>
              </div>
              <div class="flex-column-container select-box-right">
                <label
                  id="parking-search-outward-time"
                  class="header-label"
                  i18n="@@ParkingSearchOutwardTime"
                  for="parking_outward_time"
                  >Time</label
                >
                <i class="ico-clock select-box-icon" aria-hidden="true"></i>
                <select appSelect [(ngModel)]="searchParameters.outtime" id="parking_outward_time">
                  @for (time of timesArray; track time) {
                    <option [ngValue]="time">
                      {{ time }}
                    </option>
                  }
                </select>
              </div>
            </ngbd-datepicker-i18n>
          </div>
        </div>
      </div>
      <div class="half-container">
        <div class="half-block right-block">
          <div
            class="flex-row-container"
            [ngClass]="{
              'error-box': searchParameters.validationMessages?.includes(
                'Inward journey cannot be in the past.'
              )
            }"
          >
            <ngbd-datepicker-i18n>
              <div class="flex-column-container combo-box-left">
                <label
                  class="header-label date-label"
                  id="outwardjourney"
                  for="parking-search-inward-date"
                  i18n="@@apratmentSearchReturnDateAndTime"
                  >Check-out date (DD/MM/YYYY)</label
                >
                <i
                  class="ico-calendar combo-box-icon"
                  aria-hidden="true"
                  style="cursor: pointer"
                ></i>
                <app-datepicker
                  [minDate]="min_date"
                  [startDate]="searchParameters.indate || searchParameters.outdate"
                  [model]="searchParameters.indate"
                  [from]="searchParameters.outdate"
                  [to]="searchParameters.indate"
                  (newFrom)="searchParameters.outdate = $event"
                  (newTo)="searchParameters.indate = $event"
                  [class]="'combo-box'"
                  [componentId]="'parking-search-inward-date'"
                  (newDate)="searchParameters.indate = $event"
                >
                </app-datepicker>
              </div>
              <div class="flex-column-container select-box-right">
                <label
                  id="parking-search-inward-time"
                  class="header-label"
                  i18n="@@SearchTaxiPickupTime"
                  for="parking_return_time"
                  >Time</label
                >
                <i class="ico-clock select-box-icon" aria-hidden="true"></i>
                <select appSelect [(ngModel)]="searchParameters.intime" id="parking_return_time">
                  @for (time of timesArray; track time) {
                    <option [ngValue]="time">
                      {{ time }}
                    </option>
                  }
                </select>
              </div>
            </ngbd-datepicker-i18n>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<app-parking-loading-screen></app-parking-loading-screen>
